const HomeTitle = ({ title, center, color }) => {
	return (
		<h2
			className={`capitalize flex ${
				center ? "justify-center" : ""
			} items-center space-x-2 text-4xl sm:text-6xl mb-8 ${
				color ? color : "text-primary"
			} font-semibold text-center`}
		>
			<span>{title}</span>
		</h2>
	);
};

export default HomeTitle;
